"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetTripPatterns = createGetTripPatterns;
exports.getTripPatternsQuery = getTripPatternsQuery;
exports.createFindTrips = createFindTrips;

var _api = require("../api");

var _travelModes = require("../constants/travelModes");

var _query = require("./query");

var _mapper = require("./mapper");

var _utils = require("../utils");

var _geocoder = require("../geocoder");

var _config = require("../config");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_MODES = [_travelModes.FOOT, _travelModes.BUS, _travelModes.TRAM, _travelModes.RAIL, _travelModes.METRO, _travelModes.WATER, _travelModes.AIR];

function getTripPatternsVariables(params) {
  var _ref = params || {},
      from = _ref.from,
      to = _ref.to,
      _ref$searchDate = _ref.searchDate,
      searchDate = _ref$searchDate === void 0 ? new Date() : _ref$searchDate,
      _ref$arriveBy = _ref.arriveBy,
      arriveBy = _ref$arriveBy === void 0 ? false : _ref$arriveBy,
      _ref$modes = _ref.modes,
      modes = _ref$modes === void 0 ? DEFAULT_MODES : _ref$modes,
      _ref$transportSubmode = _ref.transportSubmodes,
      transportSubmodes = _ref$transportSubmode === void 0 ? [] : _ref$transportSubmode,
      _ref$wheelchairAccess = _ref.wheelchairAccessible,
      wheelchairAccessible = _ref$wheelchairAccess === void 0 ? false : _ref$wheelchairAccess,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 5 : _ref$limit,
      rest = _objectWithoutProperties(_ref, ["from", "to", "searchDate", "arriveBy", "modes", "transportSubmodes", "wheelchairAccessible", "limit"]);

  return _objectSpread(_objectSpread({}, rest), {}, {
    from: from,
    to: to,
    dateTime: searchDate.toISOString(),
    arriveBy: arriveBy,
    modes: modes,
    transportSubmodes: transportSubmodes,
    wheelchair: wheelchairAccessible,
    numTripPatterns: limit
  });
}

function createGetTripPatterns(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getTripPatterns(params, overrideConfig) {
    return (0, _api.journeyPlannerQuery)(_query.getTripPatternQuery, getTripPatternsVariables(params), (0, _config.mergeConfig)(config, overrideConfig)).then(function (data) {
      var _data$trip;

      if (!(data === null || data === void 0 ? void 0 : (_data$trip = data.trip) === null || _data$trip === void 0 ? void 0 : _data$trip.tripPatterns)) {
        return [];
      }

      return data.trip.tripPatterns.map(function (trip) {
        return _objectSpread(_objectSpread({}, trip), {}, {
          legs: trip.legs.map(_mapper.legMapper)
        });
      });
    });
  };
}

function getTripPatternsQuery(params) {
  return (0, _api.getGraphqlParams)(_query.getTripPatternQuery, getTripPatternsVariables(params));
}

function createFindTrips(argConfig) {
  var getFeatures = (0, _geocoder.createGetFeatures)(argConfig);
  var getTripPatterns = createGetTripPatterns(argConfig);
  return /*#__PURE__*/function () {
    var _findTrips = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(from, to, date) {
      var searchDate, _yield$Promise$all, _yield$Promise$all2, fromFeatures, toFeatures;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchDate = date ? new Date(date) : new Date();

              if ((0, _utils.isValidDate)(searchDate)) {
                _context.next = 3;
                break;
              }

              throw new Error('Entur SDK: Could not parse <date> argument to valid Date');

            case 3:
              _context.next = 5;
              return Promise.all([getFeatures(from), getFeatures(to)]);

            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              fromFeatures = _yield$Promise$all2[0];
              toFeatures = _yield$Promise$all2[1];

              if (!(!fromFeatures || !fromFeatures.length)) {
                _context.next = 11;
                break;
              }

              throw new Error("Entur SDK: Could not find any locations matching <from> argument \"".concat(from, "\""));

            case 11:
              if (!(!toFeatures || !toFeatures.length)) {
                _context.next = 13;
                break;
              }

              throw new Error("Entur SDK: Could not find any locations matching <to> argument \"".concat(to, "\""));

            case 13:
              return _context.abrupt("return", getTripPatterns({
                from: (0, _utils.convertFeatureToLocation)(fromFeatures[0]),
                to: (0, _utils.convertFeatureToLocation)(toFeatures[0]),
                searchDate: searchDate
              }));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function findTrips(_x, _x2, _x3) {
      return _findTrips.apply(this, arguments);
    }

    return findTrips;
  }();
}